import { BaseCustomError, ErrorCode } from './base';

export class BadRequestError extends BaseCustomError {
  constructor(details: any, errorCode: ErrorCode = ErrorCode.InvalidData) {
    super(400, 'Bad request', details, errorCode);
  }
}
